import get from 'lodash/get';

const styles = ({ color }) => ({
  userRoleInfoContent: {
    color: `${get(color, 'bodyText')} !important`,
  },
});

export default styles;
